import {
  confirmLastDialog,
  onInputEnter,
  openDrawer,
} from "@/src/components/dialogs";
import { Input } from "@/src/components/universalInput";
import {
  Billet,
  DocumentTemplate,
  EntryMode,
  ExitMode,
  Hospitalisation,
  Patient,
  PatientDocument,
  entryModes,
  exitModes,
} from "@/src/data/allTypes";
import { USER } from "@/src/data/globalVariables";
import apiFetch from "@/src/utils/apiFetch";
import {
  formatDate,
  getItemId,
  getUserId,
  getUserShortName,
} from "@/src/utils/utils";
import moment from "moment";
import { useState } from "react";
import { openDocumentForm } from "../documents/documentsHook";
import { getStandardConfidentiality } from "../patients/confidentialitiesHook";
import { wilayas } from "@/src/data/wilayas";
import { hospitals } from "@/src/data/hospitals";

export async function openBillet({
  parent,
  title,
  item,
  patient,
  onChange,
}: {
  parent: Hospitalisation;
  title?: string;
  item: Billet;
  patient: Patient;
  onChange: (item: Billet, patientDocument: PatientDocument) => void;
}) {
  if (item.patientDocument) {
    item.patientDocument = await apiFetch("patientDocuments", "loadOne", {
      id: getItemId(item.patientDocument),
    });

    return await openDocumentForm({
      patient,
      patientDocument: item.patientDocument,
    });
  }

  let template = await apiFetch("documentTemplates", "loadOne", {
    id: "documentTemplates:1717460199094jn3j2n6y8",
  });

  //todo check this
  // await openDrawer({
  //   id: "patientDrawer",
  //   title: "Patient",
  //   additionalClasses: ["small"],
  //   content: (
  //     <PatientIdentityForm
  //       initialValue={patient}
  //       onChange={(newValue) => {
  //         patient = newValue;
  //       }}
  //     />
  //   ),
  //   onConfirm: async (e) => {
  //     try {
  //       patient = await apiFetch("patients", "addOne", {
  //         patient,
  //         serviceId: getUserId(),
  //         userId: getUserId(),
  //       });
  //     } catch (e: any) {
  //       //Just an edit, never an add, so no need to handle "patientAlreadyExists" error
  //       throw e;
  //     }
  //   },
  // });

  await openDrawer({
    id: "hospitalisationInfoDrawer",
    title: "Informations supplémentaires",

    content: (
      <HospitalisationBilletForm
        current={parent}
        onChange={(newValue) => {
          parent = newValue;
        }}
      />
    ),
    // confirmOnEnter: true,
    onConfirm: async (e) => {
      await apiFetch("hospitalisations", "addOne", {
        hospitalisation: parent,
      });
      await getBilletHtmlContent({
        patient,
        title,
        template: template!,
        parent,
        item,
        onChange,
      });
      return false;
    },
  });
}

async function getBilletHtmlContent({
  patient,
  title,
  template,
  parent,
  item,
  onChange,
}: {
  template: DocumentTemplate;
  parent: Hospitalisation;
  title?: string;
  item: Billet;
  patient: Patient;
  onChange: (item: Billet, patientDocument: PatientDocument) => void;
}) {
  let patientDocument: PatientDocument = {
    patient: patient,
    creator: USER?.get(),
    template:
      template != null
        ? {
            ...template,
            showTitle: false,
          }
        : null,
    parent,
    content: getBilletHtml({
      patient,
      hospitalisation: parent,
      title: title || template?.title || "Nouveau document",
    }),
    title: "",
    status: "pending",
    refAnswer: {
      creator: USER?.get(),
      reference: template?.reference,
      patient: patient,
      fieldAnswers: [],
      notes: "",
      conclusion: "",
    },
  };

  patientDocument = await openDocumentForm({
    patient,
    patientDocument,
  });

  if (patientDocument.id) {
    item.patientDocument = getItemId(patientDocument);
    let billet = await apiFetch("billets", "addOne", {
      billet: item,
    });

    onChange(billet, patientDocument);
  }
}

function getBilletHtml({
  patient,
  title,
  hospitalisation,
}: {
  patient: Patient;
  title: string;
  hospitalisation: Hospitalisation;
}) {
  console.log("hospitalisation", hospitalisation);
  return `<div class="document-title center bold f20">${title}</div><div class=documentContent contenteditable=true style=opacity:1><div class="bold uppercase">Identification du patient</div><div class="border-section grid left"contenteditable=""style="grid-template-columns:auto 1fr auto 1fr;gap:8px 10px"><div class="crh-label dark-gray"data-id=last_name>Nom</div><div class="bold crh-val capitalize"data-id=last_name>${
    patient.lastName || "-"
  }</div><div class="crh-label dark-gray"data-id=first_name>Prénom</div><div class="bold crh-val capitalize"data-id=first_name>${
    patient.firstName || "-"
  }</div><div class="crh-label dark-gray"data-id=birth>Né le</div><div class="bold crh-val"data-id=birth>${formatDate(
    patient.birth,
    "LL"
  )}</div><div class="crh-label dark-gray"data-id=address>Adresse</div><div class="bold crh-val capitalize"data-id=address>${
    patient.address || "-"
  }</div><div class="crh-label dark-gray"data-id=address>Nationalité</div><div class="bold crh-val capitalize"data-id=nationality>${
    patient.nationality || "Algérienne"
  }</div><div class="crh-label dark-gray"data-id=profession>Profession</div><div class="bold crh-val capitalize"data-id=profession>${
    patient.profession || "-"
  }</div><div class="crh-label dark-gray"data-id=phone_number>Tel mobile</div><div class="bold crh-val"data-id=phone_number>${
    patient.phoneNumber || "-"
  }</div><div class="crh-label dark-gray"data-id=confiance>Personne de confiance</div><div class="bold crh-val"data-id=confiance>${
    patient.familyMemberFullName || "-"
  }</div><div class="crh-label dark-gray"data-id=social_security>N° Assurance</div><div class="bold crh-val"data-id=social_security>${
    patient.socialSecurityNumber || "-"
  }</div><div class="crh-label dark-gray"data-id=dossier_id>N° de dossier</div><div class="bold crh-val"data-id=dossier_id>${
    patient.recordId || patient.id?.replace("patients:", "").slice(0, 11)
  }</div><div class="crh-label dark-gray"data-id=hospitalisation_id>N° d'admission</div><div class="bold crh-val"data-id=hospitalisation_id>${
    hospitalisation.admissionNumber ||
    hospitalisation.id?.replace("hospitalisations:", "").slice(0, 11)
  }</div><div class="crh-label dark-gray"data-id=hospitalisation_id>N° de prise en charge</div><div class="bold crh-val"data-id=hospitalisation_id>-</div><div class="crh-label dark-gray"data-id=hospitalisation_date>Date d'entrée</div><div class="bold crh-val"data-id=hospitalisation_date>${formatDate(
    hospitalisation._date,
    "LL"
  )}</div><div class="crh-label dark-gray"data-id=sortie_date>Date de sortie</div><div class="bold crh-val"data-id=sortie_date>${
    formatDate(hospitalisation.discharge?.exitDate, "LL") || "-"
  }</div><div class="crh-label dark-gray"data-id=entry_mode>Mode d'entrée</div><div class="bold crh-val"data-id=entry_mode>${
    entryModes[hospitalisation.entryMode as EntryMode]?.name || "-"
  }</div><div class="crh-label dark-gray"data-id=sortie_mode>Mode de sortie</div><div class="bold crh-val"data-id=sortie_mode>${
    exitModes[hospitalisation.discharge?.exitMode as ExitMode]?.name || "-"
  }</div></div><div class="bold uppercase"><br></div><div class="bold uppercase">Identification de l'assuré</div><div class="border-section grid left"contenteditable=""style="grid-template-columns:auto 1fr auto 1fr;gap:8px 10px"><div class="crh-label dark-gray"data-id=social_security>N° Assurance</div><div class="bold crh-val"data-id=social_security>${
    patient.socialSecurityNumber || "-"
  }</div><div class="crh-label dark-gray"data-id=social_security>N° prise en charge</div><div class="bold crh-val"data-id=social_security>-</div><div class="crh-label dark-gray"data-id=last_name>Nom</div><div class="bold crh-val capitalize"data-id=last_name>${
    patient.lastName || "-"
  }</div><div class="crh-label dark-gray"data-id=first_name>Prénom</div><div class="bold crh-val capitalize"data-id=first_name>${
    patient.firstName || "-"
  }</div><div class="crh-label dark-gray"data-id=birth>Né le</div><div class="bold crh-val"data-id=birth>${formatDate(
    patient.birth,
    "LL"
  )}</div><div class="crh-label dark-gray"data-id=affiliation>Caisse d'affiliation</div><div class="bold crh-val capitalize"data-id=affiliation>${
    patient.assuranceAffiliation || "-"
  }</div></div><div class="bold uppercase"><br></div><div class="bold uppercase">Hospitalisation</div><div class="border-section grid"style="grid-template-columns:auto 1fr;gap:8px 10px"><div class="crh-label dark-gray">Service d'hospitalisation</div><div class=bold>${
    USER.get()?.service?.name
  }</div><div class="crh-label dark-gray">Décidé par</div><div class=bold>${
    getUserShortName(hospitalisation.decisionDoctor) || "-"
  }</div><div class="crh-label dark-gray">Type d'admission</div><div class=bold>${
    entryModes[hospitalisation.entryMode as EntryMode]?.name || "-"
  }</div><div class="crh-label dark-gray">Date d'admission</div><div class=bold>${
    formatDate(hospitalisation._date, "LL") || "-"
  }</div><div class="crh-label dark-gray">Diagnostic(s) à l'admission</div><div class=bold>${
    // hospitalisation.diagnostics
    //   ?.map((d) => d?.reference?.name || "")
    //   .filter((a) => a)
    //   .join(", ") || "-"

    "-"
  }</div><div class="crh-label dark-gray">Etablissement d'origine</div><div class=bold>${
    USER.get()?.service?.name || "-"
  }</div></div><div class="bold uppercase"><br></div><div class="bold uppercase">Accident</div><div class=border-section><div class="grid left"contenteditable=""style="grid-template-columns:auto 1fr auto 1fr;gap:8px 10px"><div class="crh-label dark-gray"data-id=social_security>Type d'accident</div><div class=bold></div><div class="crh-label dark-gray"data-id=social_security>Date de l'évènement</div><div class=bold></div><div class="crh-label dark-gray"data-id=social_security>Patient transporté par</div><div class=bold></div><div class="crh-label dark-gray"data-id=social_security>Autorité chargée de l'enquête</div><div class=bold></div></div></div>
  <div class=right contenteditable="">Date: <strong>${formatDate(
    hospitalisation._date,
    "LL"
  )}</strong></div><div style=text-align:right>Signature et cachet</div></div>
  `;
}

export function HospitalisationBilletForm({
  current,
  onChange,
}: {
  current: Hospitalisation;
  onChange: (patient: Hospitalisation) => void;
}) {
  let [value, setValue] = useState<Hospitalisation>(current);

  function onLocalChange(newValue: Hospitalisation) {
    setValue(newValue);
    onChange(newValue);
  }

  return (
    <div id="patient_form" className="grid c1 gap15">
      <Input
        name="N° d'admission"
        type="text"
        shouldFocus={true}
        onEnter={onInputEnter}
        value={value.admissionNumber || Date.now().toString().slice(5)}
        onChange={(newValue) => {
          onLocalChange({ ...value, admissionNumber: newValue });
        }}
      ></Input>

      <Input
        name="Date d'entrée"
        type="date"
        value={moment(value._date).format("YYYY-MM-DD")}
        onEnter={onInputEnter}
        onChange={(newValue) => {
          onLocalChange({
            ...value,
            _date: moment(newValue).format("YYYY-MM-DD HH:mm:ss"),
          });
        }}
      ></Input>
      <Input
        name="Mode d'entrée"
        type="select"
        value={value.entryMode}
        onEnter={onInputEnter}
        options={Object.values(entryModes).map((entryMode) => ({
          value: entryMode.id,
          label: entryMode.name,
        }))}
        onChange={(newValue) => {
          onLocalChange({ ...value, entryMode: newValue });
        }}
      ></Input>
      {value.entryMode === "evacuation" && (
        <>
          <Input
            name="Wilaya d'origine"
            type="select"
            value={value.sourceWilaya}
            onEnter={onInputEnter}
            options={wilayas.map((wilaya) => {
              return { value: wilaya, label: wilaya };
            })}
            onChange={(newValue) => {
              onLocalChange({ ...value, sourceWilaya: newValue });
            }}
          ></Input>

          <Input
            key={`${value.sourceWilaya} commune`}
            name="Commune"
            type="select"
            value={value.sourceHospitalName}
            onEnter={onInputEnter}
            options={
              hospitals[
                (value.sourceWilaya || "Alger") as keyof typeof hospitals
              ]?.hospital.map((hospital) => {
                return { value: hospital, label: hospital };
              }) || []
            }
            onChange={(newValue) => {
              onLocalChange({ ...value, sourceHospitalName: newValue });
            }}
          ></Input>
        </>
      )}

      <Input
        name="Date de sortie (Si sortie)"
        type="date"
        onEnter={onInputEnter}
        value={moment(value.discharge?.exitDate).format("YYYY-MM-DD")}
        onChange={(newValue) => {
          value.discharge ||= {
            exitMode: "authorized",
            confidentiality: getStandardConfidentiality(value.patient),
            creator: getUserId(),
            patient: getItemId(value.patient),
            readBy: [],
            parent: getItemId(value),
            type: "discharge",
            dischargeType: "planned",
            status: "pending",
            exitDate: newValue,
            notes: "",
            conclusion: "",
          };
          onLocalChange({
            ...value,
            discharge: {
              ...value.discharge,
              exitDate: moment(newValue).format("YYYY-MM-DD HH:mm:ss"),
            },
          });
        }}
      ></Input>
      {value.discharge?.exitDate && (
        <Input
          name="Mode de sortie (si sortie)"
          type="select"
          value={value.discharge?.exitMode}
          onEnter={onInputEnter}
          options={Object.values(exitModes).map((exitMode) => ({
            value: exitMode.id,
            label: exitMode.name,
          }))}
          onChange={(newValue) => {
            if (value.discharge) {
              onLocalChange({
                ...value,
                discharge: { ...value.discharge, exitMode: newValue },
              });
            }
          }}
        ></Input>
      )}

      <Input
        name="Notes (optionnel)"
        type="textarea"
        value={value?.notes || ""}
        onEnter={onInputEnter}
        onChange={(newValue) => {
          onLocalChange({
            ...value,
            notes: newValue,
          });
        }}
      ></Input>
    </div>
  );
}

export async function openHospitalisationBilletForm(
  hospitalisation: Hospitalisation,
  onConfirm: (hospitalisation: Hospitalisation) => void
) {
  await openDrawer({
    id: "statusChoiceDrawer",
    title: "Informations sur l'hospitalisation",
    content: (
      <div className="c1 gap10">
        <HospitalisationBilletForm
          current={hospitalisation}
          onChange={(newValue) => {
            hospitalisation = newValue;
          }}
        />
      </div>
    ),
    onConfirm: async () => {
      onConfirm(hospitalisation);
    },
  });
}
